import React, { useEffect } from 'react';
import Box from 'react-styled-box';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import _get from 'lodash/get';
import store from 'store';
import { loadPublicRegConsents } from 'customerActions.js';
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';
import { translation } from 'helpers/utilsHelper.js';
import { renderField, renderCheckboxField, renderMultiSelectDropdown, handleChatClick } from 'helpers/registerHelper.js';
import S from './StyledRegisterFormByMyIdStep2.js';

const validate = values => {
    const errors = validation(values, validators.REGISTER_BANK_STEP2);
    return errors;
};

const RegisterFormByMyIdStep2 = ({ 
    onSubmit,
    initialValues,
    handleSubmit, 
    submitting, 
    loadPublicRegConsents, 
    sofOptions, 
    pep, 
    giif,
    giifVal,
    pepVal,
    selectAllVal,
    isCountryLocked,
    dispatch
}) => {
    useEffect(() => {
        loadPublicRegConsents('CUSTOMER_MY_ID_REGISTRATION');
    }, []);

    useEffect(() => {
        const areAllChecked = !!(giifVal && pepVal);

        if (areAllChecked !== !!selectAllVal) {
            dispatch(change('registerWizardForm', 'selectAll', areAllChecked));
        }
    }, [giifVal, pepVal, dispatch]);

    const handleSelectAllChange = (event, newValue) => {
        dispatch(change('registerWizardForm', 'giifDeclaration', newValue));
        dispatch(change('registerWizardForm', 'pepDeclaration', newValue));
    };

    return (
        <S.FormStep2 onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <S.FieldsGrid>
                <Field name="city" component={renderField} S={S} label={translation('registerFormBank_city')} fullWidth disabled={!!initialValues?.city}/>
                <Field name="street" component={renderField} S={S} label={translation('registerFormBank_street')} fullWidth disabled={!!initialValues?.street}/>
                <Field name="houseNumber" component={renderField} S={S} label={translation('registerFormBank_houseNumber')} disabled={!!initialValues?.houseNumber}/>
                <Field name="postalCode" component={renderField} S={S} label={translation('registerFormBank_postalCode')} disabled={!!initialValues?.postalCode}/>
                
                <Field name="country" component={renderField} S={S} label={translation('registerFormBank_country')} disabled={isCountryLocked} fullWidth/>
            </S.FieldsGrid>

            <S.CheckboxesSection>
                <S.CheckboxWrapper>
                    <Field name="selectAll" component={renderCheckboxField} S={S} label={translation('registerFormBank_selectAll')} onChange={handleSelectAllChange}/>
                </S.CheckboxWrapper>

                {giif.map((consent) => (
                    <Field key={consent.definitionId} name="giifDeclaration" type="checkbox" component={renderCheckboxField} S={S} label={consent.name}/>
                ))}

                {pep.map((consent) => (
                    <Field key={consent.definitionId} name="pepDeclaration" type="checkbox" component={renderCheckboxField} S={S} label={consent.name}/>
                ))}
            </S.CheckboxesSection>

            <S.SourceSection>
                <S.SourceTitle>{translation('registerFormBank_sourceOfFundsTitle')}</S.SourceTitle>
                <S.SourceInfo>{translation('registerFormBank_sourceOfFundsInfo')}</S.SourceInfo>
                <Field 
                    name="sourceOfFunds" 
                    component={renderMultiSelectDropdown} 
                    S={S} 
                    options={sofOptions}
                    placeholder={translation('registerFormBank_sourcePlaceholder')}
                />
            </S.SourceSection>

            <S.SubmitBtn type="submit" disabled={submitting}>
                {translation('registerFormBank_next')}
            </S.SubmitBtn>

            <S.FooterInfo>
                <S.ContactInfo>{translation('registerFormBank_needHelp')}</S.ContactInfo>
                <S.ContactLink onClick={handleChatClick}>
                    {translation('registerFormBank_contactUs')}
                </S.ContactLink>
            </S.FooterInfo>
        </S.FormStep2>
    );
};

const selector = formValueSelector('registerWizardForm');

const mapStateToProps = (state) => {
    const allItems = _get(state, 'Customer.registrationConsents.CUSTOMER_MY_ID_REGISTRATION', []);

    return {
        sofOptions: allItems.filter(item => item.container === 'SOW'),
        pep: allItems.filter(item => item.container === 'PEP'),
        giif: allItems.filter(item => item.container === 'GIIF'),
        giifVal: selector(state, 'giifDeclaration'),
        pepVal: selector(state, 'pepDeclaration'),
        selectAllVal: selector(state, 'selectAll')
    };
};

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ loadPublicRegConsents }, dispatch),
    dispatch
});

const connectedForm = connect(mapStateToProps, mapDispatchToProps)(RegisterFormByMyIdStep2);

export default reduxForm({
    form: 'registerWizardForm',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
})(connectedForm);